import { Icon, iconSizes } from "@hubrise/react-components"
import styled from "styled-components"

import { clickableRoundIcon } from "shared/styles/common"

export const ActionLink = styled.div`
  ${clickableRoundIcon};
`

export const ActionIcon = styled(Icon).attrs({ code: "more_vert", size: iconSizes._20 })``
